module.exports = __webpack_public_path__ + "static/media/help-icon.07589de2.svg";